import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  deletedUsers: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the
export const fetchDeletedUsers = createAsyncThunk(
  "fetchDeletedUsers/deletedUsers",
  async ({ enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`get-deleted-account`, {
        params: {
          limit,
          page: page + 1,
        },
      });
      return {
        data: response.data.data.items,
        meta: response.data.data.meta,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const deletedUserSlice = createSlice({
  name: "deletedUsers",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch team members
    builder.addCase(fetchDeletedUsers.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchDeletedUsers.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.deletedUsers = action.payload;
    });

    builder.addCase(fetchDeletedUsers.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default deletedUserSlice.reducer;
